<template>
  <div
    class="flex items-center p-2 text-sm text-gray-800 rounded-xl mb-2"
    :class="alertBackroundClass"
    role="alert"
    v-if="uiNotificationType && uiNotificationTitle && uiNotification"
  >
    <WarningSign></WarningSign>
    <span class="sr-only">Info</span>
    <div class="ml-3">
      <span class="font-bold">{{ uiNotificationTitle }}</span>
      <p class="text-xxs">{{ uiNotification }}</p>
    </div>
  </div>
</template>
<script>
import WarningSign from '@/Components/Icons/DeviceAndSessionSetup/WarningSign.vue';

export default {
  name: 'DeviceSetupAlert',
  props: {
    uiNotificationType: {
      type: String,
      required: false,
      default: null,
    },
    uiNotificationTitle: {
      type: String,
      required: false,
      default: null,
    },
    uiNotification: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    WarningSign,
  },
  computed: {
    alertBackroundClass() {
      switch (this.uiNotificationType) {
        case 'Warning':
          return 'background-warning';
        case 'Info':
          return 'background-info';
        default:
          return '';
      }
    },
  },
};
</script>
<style scoped>
.background-warning {
  background-color: #fef3c7;
}

.background-info {
  background-color: #eeeeee;
}
</style>
